export default __webpack_public_path__ + "static/media/Scentpad-fresh-dew.8aa7f4bf.jpg";